import { render, staticRenderFns } from "./ListUserChat.vue?vue&type=template&id=87f9027c"
import script from "./ListUserChat.vue?vue&type=script&lang=js"
export * from "./ListUserChat.vue?vue&type=script&lang=js"
import style0 from "./ListUserChat.vue?vue&type=style&index=0&id=87f9027c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports